export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13465.58c5d380.jpg";